import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'
import { v2ReservationCellKeys } from './use-v2-reservationcell-find-query'

type RemoveReservationCellBody = Parameters<typeof apiClient.v2.apiV2ReservationcellElRemove>[0]

const removeReservationCell = async (body: RemoveReservationCellBody) => {
  const { data } = await apiClient.v2.apiV2ReservationcellElRemove(body)
  return checkApiResponse(data)
}

export const useV2ReservationCellRemoveMutation = ({ options }: MutationComposableParams<unknown, RemoveReservationCellBody> = {}) => {
  const queryClient = useQueryClient()
  return useMutation(() => {
    const resolved = resolveMaybeGetter(options ?? {})
    return {
      mutationFn: removeReservationCell,
      ...resolved,
      // 저장 성공 시 도메인 캐시를 무효화한다 — 다음 조회가 fresh 데이터를 가져온다
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: v2ReservationCellKeys.all })
        return (resolved as { onSuccess?: (...args: unknown[]) => unknown }).onSuccess?.(data, variables, context)
      },
    }
  })
}
